import {
  PartyForCard,
  getGuestProfile,
  getPurchaseInfo,
  getQuickTags,
  getSmsInfo,
  getVisitNote,
  getVisitTags,
  isServiceParty,
} from 'components/service/party/partyRedesignCard/partyType';
import { guestListShowTagsSelector } from 'selectors/dashboardPreferenceSelectors';
import { partyCardDescriptionCssDefs } from 'components/service/party/partyRedesignCard/partyCardCssDefs';
import { useIsCompactView } from 'hooks/useIsCompactView';
import { useSelector } from 'react-redux';
import GuestAndVisitIcons from 'components/crm/GuestAndVisitIcons';
import _ from 'lodash';

interface Props {
  party: PartyForCard;
  renderDot?: boolean;
}

const PartyRedesignIcons: React.FC<Props> = ({ party, renderDot }) => {
  const isCompactView = useIsCompactView();
  const { confirmedViaSms, hasUnreadSms, lastSmsStatus } = getSmsInfo(party);
  const showGuestListTags = useSelector(guestListShowTagsSelector);

  const guestProfile = getGuestProfile(party);
  const visitNote = getVisitNote(party);
  const visitTags = getVisitTags(party);
  const quickTags = getQuickTags(party);

  let hasVisitNote;
  let hasVisitDietaryNote = false;

  if (isServiceParty(party)) {
    hasVisitNote = false;
    for (const auditedNote of party.purchase?.auditedBookingNote ?? []) {
      if (!_.isEmpty(auditedNote.note)) {
        if (auditedNote.noteType === 'DIETARY') {
          hasVisitDietaryNote = true;
        } else {
          hasVisitNote = true;
        }
      }
      if (hasVisitNote && hasVisitDietaryNote) {
        // save ourselves some work; short-circuit the loop
        break;
      }
    }
  } else {
    hasVisitNote = !!visitNote;
  }

  const {
    hasAnsweredQuestion,
    hasPurchasedSupplements,
    hasDelivered,
    hasDeliverySignatureRequirement,
    requiresPayment,
  } = getPurchaseInfo(party);

  const renderIcons = (
    <>
      {showGuestListTags && (
        <GuestAndVisitIcons
          guestProfile={guestProfile}
          visitTags={visitTags}
          quickTags={quickTags}
          visitNote={visitNote}
          hasBeenConfirmed={confirmedViaSms}
          hasQuickNote={false /* note text is now always shown on card */}
          hasVisitNote={false /* note text is now always shown on card */}
          hasVisitDietaryNote={hasVisitDietaryNote}
          hasPaymentRequired={requiresPayment}
          hasNewMessage={hasUnreadSms}
          hasAnsweredQuestion={hasAnsweredQuestion}
          hasPurchasedSupplements={hasPurchasedSupplements}
          hasDelivered={hasDelivered}
          lastTextMessageStatus={lastSmsStatus}
          hasDeliverySignatureRequirement={hasDeliverySignatureRequirement}
          noParentWrapper
          renderDot={renderDot}
          isPartyCard
          maxIconsToDisplay={isCompactView ? 4 : undefined}
        />
      )}
    </>
  );

  if (isCompactView) {
    return <div css={partyCardDescriptionCssDefs.iconContainer}>{renderIcons}</div>;
  } else {
    return renderIcons;
  }
};

export default PartyRedesignIcons;
